import { XrayRemoteControlConnectionInfo } from '@bymason/controller-api-hooks';

export {
  XrayRemoteControlConnectionInfo,
  useGetLogBuffers,
  useXrayLogStreamConnection,
} from '@bymason/controller-api-hooks';

export interface XrayRemoteControlMethods {
  start: () => void;
  stop: () => void;
}

export interface XrayRemoteControlProps {
  clientToken: string;
  deviceId: string;
  pendingBackgroundColor?: string;
  viewportBorderRadius?: number;
  onConnectionInfo?: (info: XrayRemoteControlConnectionInfo) => void;
  onError?: (error: string) => void;
  onStart?: () => void;
  onStop?: () => void;
  onTimeout?: () => void;
  onTimeoutWarning?: (remainingSeconds: number, reset: () => void) => void;
}

export interface XrayRemoteControlRfbError {
  friendlyError?: string;
  technicalError: string;
}
